<div class="row">
    <div class="col-md-12">
        <div class="card card-primary mr-2">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12">
                        <app-productQuery></app-productQuery>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
